
import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from "vue-property-decorator";

@Component
export default class Error extends Vue {
    @Prop({required: true})
    description! : string

    @Prop({required: false, default: null})
    statusCode! : number | null
    
    get hasHistory() {
        return window.history.length > 3
    }
    
    goBack() {
        this.$router.go(-2); // NOTE: Go back by 2 to skip error re-appearing.
    }
}
